import {useEffect, useState} from 'react'
import {IReport, MainReportData} from '../types/report.types'

type PaginationType = {
  totalPages: number
  page: number
  pagingCounter: number
  hasPrevPage: boolean
  hasNextPage: boolean
  prevPage: number | null
  nextPage: number | null
}

type Response = {
  getReportList: MainReportData
  loading: boolean
}

type FetchResponse = {
  reports: IReport[]
  error: boolean
  loading: boolean
  pagination: PaginationType
  refetchReports: () => void
}

const useFetchReports = (
  page: number,
  status: string,
  category: string,
  startDate: string,
  endDate: string,
  searchString: string
): FetchResponse => {
  const [reports, setReports] = useState<IReport[]>([])
  const [error, setError] = useState(false)
  const [pagination, setPagination] = useState<PaginationType>({
    totalPages: 0,
    page: 1,
    pagingCounter: 0,
    hasPrevPage: false,
    hasNextPage: false,
    prevPage: null,
    nextPage: null,
  })

  const [loading, setLoading] = useState(true)

  const fetchReports = async () => {
    try {
    } catch (error) {
      setLoading(false)
      setError(true)
    } finally {
      setLoading(false)
    }
  }

  const refetchReports = async () => {
    await fetchReports()
  }

  useEffect(() => {
    fetchReports()
  }, [])
  return {reports, error, loading, pagination, refetchReports}
}

export default useFetchReports
